/**
 * Datas/horas no Gestão: o usuário opera no fuso do navegador (SO/PC),
 * a API persiste em UTC. Não há offset fixo (GMT-3); funciona em qualquer fuso.
 */

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

function asDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** ISO/Date → valor de input `date` (yyyy-MM-dd) no fuso local. */
export function toDateInputValue(isoOrDate) {
  const date = asDate(isoOrDate);
  if (!date) return '';
  const offset = date.getTimezoneOffset();
  return new Date(date.getTime() - offset * 60000).toISOString().slice(0, 10);
}

/** ISO/Date → valor de input `datetime-local` no fuso local. */
export function toDatetimeLocalValue(isoOrDate) {
  const date = asDate(isoOrDate);
  if (!date) return '';
  const offset = date.getTimezoneOffset();
  return new Date(date.getTime() - offset * 60000).toISOString().slice(0, 16);
}

/** `datetime-local` → ISO UTC para API. */
export function fromDatetimeLocalValue(localValue) {
  if (!localValue) return new Date().toISOString();
  return new Date(localValue).toISOString();
}

/** Input `date` (yyyy-MM-dd) → início do dia local em ISO UTC. */
export function localDayStartIso(dateInputValue) {
  if (!dateInputValue) return '';
  if (DATE_ONLY.test(dateInputValue)) {
    return new Date(`${dateInputValue}T00:00:00`).toISOString();
  }
  const date = asDate(dateInputValue);
  return date ? date.toISOString() : '';
}

/** Input `date` (yyyy-MM-dd) → fim do dia local em ISO UTC. */
export function localDayEndIso(dateInputValue) {
  if (!dateInputValue) return '';
  if (DATE_ONLY.test(dateInputValue)) {
    return new Date(`${dateInputValue}T23:59:59.999`).toISOString();
  }
  const date = asDate(dateInputValue);
  return date ? date.toISOString() : '';
}

/**
 * Normaliza parâmetro de período para query da API.
 * Aceita yyyy-MM-dd, ISO completo ou Date.
 */
export function toApiDateStart(value) {
  if (value == null || value === '') return '';
  if (value instanceof Date) return value.toISOString();
  if (typeof value === 'string' && DATE_ONLY.test(value)) {
    return localDayStartIso(value);
  }
  if (typeof value === 'string') return value;
  return new Date(value).toISOString();
}

export function toApiDateEnd(value) {
  if (value == null || value === '') return '';
  if (value instanceof Date) return value.toISOString();
  if (typeof value === 'string' && DATE_ONLY.test(value)) {
    return localDayEndIso(value);
  }
  if (typeof value === 'string') return value;
  return new Date(value).toISOString();
}

/** Exibição de data/hora UTC da API no fuso local do usuário. */
export function formatDateTimeLocale(isoOrDate, locale = 'pt-BR') {
  const date = asDate(isoOrDate);
  if (!date) return '-';
  return date.toLocaleString(locale, { dateStyle: 'short', timeStyle: 'short' });
}
